export default __webpack_public_path__ + "static/photo3-46df2380e40994281b700e9dc790deef.jpg";